import { Button, TextField } from "@material-ui/core";
import React, { Component } from "react";
import { Redirect } from "react-router-dom";
import ApiFetcher from "../../ApiFetcher";
import { withStyles } from '@material-ui/core/styles';

const styles = theme => ({
    root: {
        textAlign: 'center'
    },
    generalButton: {
        margin: theme.spacing.unit,
    },
    textField: {
        margin: theme.spacing.unit,
    },
    form: {
        margin: 'auto',
        marginTop: theme.spacing.unit * 2,
        marginBottom: theme.spacing.unit * 2,
        width: '80%',
    },
    errorMessage: {
        color: 'red'
    }
});

class Mfa extends Component {
    constructor(props) {
        super(props);

        this.state = {
            mfaCode: '',
            error: []
        };
    }

    onClickSubmitButton = () => {
        ApiFetcher.postMfa(JSON.stringify({
            mfaCode: this.state.mfaCode,
            mailAddress: this.props.location.state.mailAddress,
            password: this.props.location.state.password,
        }), (responseJson) => {
            if (responseJson.message === null || responseJson.message === "") {
                // cookieをセット
                this.props.cookies.set('id', responseJson.result.id, { path: '/', secure: true });
                this.props.cookies.set('role', responseJson.result.role, { path: '/', secure: true });
                this.props.cookies.set('token', responseJson.result.token, { path: '/', secure: true });
                // ページ遷移.
                this.props.history.replace(this.getRedirectTo().pathname);
            } else {
                this.setState({ error: responseJson.message });
            }
        })
    }

    getRedirectTo() {
        return { pathname: '/' };
    }

    isLogin() {
        let id = this.props.cookies.get('id');
        let role = this.props.cookies.get('role');
        let token = this.props.cookies.get('token');
        if (id === undefined || role === undefined || token === undefined) {
            return false;
        }
        return true;
    }

    static convertErrorMessagePropertyName(propertyName) {
        if (propertyName === 'mailAddress') {
            return 'メールアドレス:';
        }
        else if (propertyName === 'password') {
            return 'パスワード:';
        }
        else {
            return '';
        }
    }

    render() {
        // ログイン済みの場合はリダイレクト.
        if (this.isLogin()) {
            return <Redirect to={this.getRedirectTo()} />;
        }

        // ログイン画面からの遷移でない場合はログイン情報がないためリダイレクト
        if (
            this.props.location.state == null ||
            this.props.location.state.mailAddress == null ||
            this.props.location.state.password == null
        ) {
            return <Redirect to={this.getRedirectTo()} />;
        }

        return (
            <div className={this.props.classes.root}>
                <div className={this.props.classes.form}>
                    <div id="errors">
                        {this.state.error.map((row, i) => {
                            return (
                                <div key={i} className={this.props.classes.errorMessage}>
                                    {Mfa.convertErrorMessagePropertyName(row.propertyName)}{row.errorMessage}
                                </div>
                            )
                        })}
                    </div>
                    <TextField
                        className={this.props.classes.textField}
                        label="認証コード"
                        type="number"
                        variant="outlined"
                        fullWidth
                        onChange={(value) => this.setState({ mfaCode: value.target.value })}
                    />
                    <Button
                        className={this.props.classes.generalButton}
                        variant="contained"
                        color="primary"
                        fullWidth
                        onClick={this.onClickSubmitButton}>
                        送信
                    </Button>
                </div>
            </div>
        )
    }
}

export default withStyles(styles)(Mfa);
